import React, { useMemo, useReducer, createContext } from "react";
import {
  setLocalStorageItem,
  removeLocalStorageItem,
  clearLocalStorage,
} from "../actionTypes/providers";

export const StorageContext = createContext();

const StorageProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    // eslint-disable-next-line consistent-return
    (_prevState, action) => {
      switch (action.type) {
        case setLocalStorageItem: {
          if (!!action?.value && !!action?.name) {
            localStorage.setItem(action?.name, action?.value);
            return {
              [action.name]: action?.value,
            };
          }
          break;
        }
        case removeLocalStorageItem: {
          if (!!action?.name) {
            localStorage.removeItem(action?.name);
            return {
              [action.name]: "",
            };
          }
          break;
        }
        case clearLocalStorage: {
          if (!!action?.name) {
            localStorage.clear();
            return state;
          }
          break;
        }
        default:
          return {
            ...state,
          };
      }
    },
    {
      jwtToken: localStorage?.getItem("jwtToken") || "",
      profileData: localStorage?.getItem("profileData"),
    }
  );

  const storageContext = useMemo(
    () => ({
      setLocalStorageItem: ({ name, value }) =>
        dispatch({ type: setLocalStorageItem, name, value }),
      removeLocalStorageItem: ({ name }) =>
        dispatch({ type: removeLocalStorageItem, name }),
      clearLocalStorage: () => dispatch({ type: clearLocalStorage }),
    }),
    []
  );

  return (
    <StorageContext.Provider value={{ storageContext, ...state }}>
      {children}
    </StorageContext.Provider>
  );
};

export default StorageProvider;
